import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { useUpdatePropertyMutation } from '../store/docApi';
import { Add } from '@mui/icons-material';
import PartCard from './PartCard';
import { generateEntityId } from '../utils';

export default function Parts({ item }) {
  const navigate = useNavigate();
  const [updateProperty] = useUpdatePropertyMutation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [newPart, setNewPart] = useState({ name: '', steps: [] });
  const [newPartId, setNewPartId] = useState(generateEntityId('part'));

  const addPart = () => {
    updateProperty({ label: item.label, pk: item.pk, id: item.id, name: `parts/${newPartId}`, value: newPart });
    setNewPart({ name: '', steps: [] });
    setNewPartId(generateEntityId('part'));
    setIsDialogOpen(false);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Parts
      </Typography>
      <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))' }}>
        {item.parts &&
          Object.entries(item.parts).map(([id, part]) => (
            <PartCard key={id} part={part} onClick={() => navigate(`/workspaces/${item.pk}/${item.id}/parts/${id}`)} />
          ))}
      </Box>
      <Button variant="outlined" startIcon={<Add />} onClick={() => setIsDialogOpen(true)} sx={{ mt: 2 }}>
        Add Part
      </Button>
      <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} fullWidth>
        <DialogTitle>Add New Part</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1 }}>
            ID
          </Typography>
          <TextField
            value={newPartId}
            onChange={(e) => setNewPartId(e.target.value)}
            fullWidth
            size="small"
            sx={{ mb: 2 }}
          />
          <Typography variant="body2" sx={{ mb: 1 }}>
            Name
          </Typography>
          <TextField
            value={newPart.name}
            onChange={(e) => setNewPart({ ...newPart, name: e.target.value })}
            fullWidth
            size="small"
            sx={{ mb: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => setIsDialogOpen(false)}>
            Cancel
          </Button>
          <Button variant="contained" onClick={addPart}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
